
import { Vue, Component } from 'vue-property-decorator';
import { Button, Toast } from 'vant';

Vue.use(Button).use(Toast);

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
  'beforeRouteUpdate', // for vue-router 2.2+
]);

@Component
export default class HelloWorld extends Vue {
  code = '';

  beforeRouteEnter(to: any, from: any, next: any) {
    if (process.env.NODE_ENV === 'production') {
      location.href = 'https://wap.cqcb.com';
    } else {
      next();
    }
  }

  created() {
    console.log('hello world');
  }
  onNavTo() {
    if (this.code === 'syxw') {
      this.$router.push('/demo');
    } else {
      Toast.fail('wrong code~');
    }
  }
}
